var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.shouldShowLightbox,
          expression: "shouldShowLightbox"
        }
      ],
      staticClass: "lightbox",
      class: _vm.getLightboxClasses,
      attrs: { for: _vm.name },
      on: {
        mousedown: function($event) {
          return _vm.$root.lightboxClick($event)
        }
      }
    },
    [
      _vm.layout
        ? [
            _vm.layout === "split-view"
              ? _c("div", { staticClass: "lightbox__form-container" }, [
                  _c("div", {
                    staticClass: "lightbox__image",
                    class: _vm.getImageClasses
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "lightbox__form" },
                    [_vm._t("default")],
                    2
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.layout === "reverse-split-view"
              ? _c("div", { staticClass: "lightbox__form-container" }, [
                  _c(
                    "div",
                    { staticClass: "lightbox__form" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "lightbox__image",
                    class: _vm.getImageClasses
                  })
                ])
              : _vm._e()
          ]
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }